var _rect, _rect2, _rect3, _rect4, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGrowth = function SvgGrowth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10.678,
    height: 10.678,
    x: 4,
    y: 54.22,
    fill: "#B4CFFF",
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10.678,
    height: 17.085,
    x: 21.085,
    y: 47.813,
    fill: "#2F68D1",
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 10.678,
    height: 27.763,
    x: 39.237,
    y: 37.136,
    fill: "#6C9BF1",
    rx: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 10.678,
    height: 54.458,
    x: 56.322,
    y: 10.441,
    fill: "#2F68D1",
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF9D43",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M5.068 43.008C23.22 38.738 38.17 27.97 42.975 5.636"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF9D43",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m48.567 14.552-5.219-9.45-9.45 5.218"
  })));
};
export default SvgGrowth;